export default __webpack_public_path__ + "static/media/warning--soft-road-surface--g2.31a8fbb4.png";